var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer",on:{"click":_vm.expand}},[(!_vm.expanded)?_c('r-icon',{attrs:{"name":"expand_more","size":_vm.size}}):_c('r-icon',{attrs:{"name":"expand_less","size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }